(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nb-pdp-trust"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nb-product-trust')){
  customElements.define('nb-product-trust',class extends HTMLElement{
    connectedCallback(){
      this.clock=this.querySelector('[data-nb-daily-clock]');
      if(!this.clock)return;
      this.formatter=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Amsterdam',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
      this.tick();this.timer=setInterval(()=>this.tick(),1000);
    }
    parts(time){return Object.fromEntries(this.formatter.formatToParts(new Date(time)).filter(p=>p.type!=='literal').map(p=>[p.type,Number(p.value)]));}
    tick(){
      const now=Date.now(),p=this.parts(now),key=p.year+'-'+p.month+'-'+p.day;
      if(this.day!==key){
        const localMidnight=Date.UTC(p.year,p.month-1,p.day+1);let estimate=localMidnight;
        for(let i=0;i<3;i++){const c=this.parts(estimate);const offset=Date.UTC(c.year,c.month-1,c.day,c.hour,c.minute,c.second)-estimate;estimate=localMidnight-offset;}
        this.end=estimate;this.day=key;
      }
      const seconds=Math.max(0,Math.ceil((this.end-now)/1000));
      const h=Math.floor(seconds/3600),m=Math.floor(seconds%3600/60),s=seconds%60;
      this.clock.textContent=[h,m,s].map(n=>String(n).padStart(2,'0')).map((n,i)=>n+' '+['h','m','s'][i]).join(' ');
      this.querySelector('[data-nb-daily]').hidden=false;
    }
    disconnectedCallback(){clearInterval(this.timer);}
  });
}
  } catch(e) { console.error(e); }
})();

})();
